import type { AndroidDeviceData, RetrieveLaunchParamsResult } from '@tma.js/sdk-react';
import { createContext, useContext } from 'react';
interface TelegramContextType {
  launchParams: RetrieveLaunchParamsResult | undefined;
  rawInitData: string | undefined;
  deviceInfo: AndroidDeviceData | undefined;
}
const TelegramContext = createContext<TelegramContextType | undefined>(undefined);
export const useTelegram = () => {
  const context = useContext(TelegramContext);
  if (!context) {
    throw new Error("useTelegram must be used within TelegramProvider");
  }
  return context;
};
export default TelegramContext;